
import { useQuery } from "@tanstack/react-query";
import { fetchAllPublicReviews } from "@/services/reviewService";

interface ProviderReview {
  id: string;
  provider_id: string;
  rating: number;
  is_public: boolean;
}

/**
 * Custom hook to fetch all provider reviews for the explore page
 */
export function useProviderReviews() {
  return useQuery({
    queryKey: ['allProviderReviews'],
    queryFn: async () => {
      try {
        return await fetchAllPublicReviews();
      } catch (error) {
        console.error("Error fetching reviews:", error);
        return {};
      }
    },
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
}
